<template>
  <d-card class="card-small mb-4 pt-3">

    <!-- Card Header -->
    <d-card-header class="border-bottom text-center">

      <!-- User Avatar -->
      <div class="mb-3 mx-auto">
        <img class="rounded-circle" :src="userDetails.avatar" :alt="userDetails.name" width="110">
      </div>

      <!-- User Name -->
      <h4 class="mb-0">{{ userDetails.name }}</h4>

      <!-- User Job Title -->
      <span class="text-muted d-block mb-2">{{ userDetails.jobTitle }}</span>

    </d-card-header>

  </d-card>
</template>

<script>
const defaultUserDetails = {
  name: 'Admin',
  avatar: require('@/assets/images/avatars/enhanced-buzz.jpeg'),
  jobTitle: 'Administrador',
};

export default {
  name: 'user-details',
  props: {
    userDetails: {
      type: Object,
      default() {
        return defaultUserDetails;
      },
    },
  },
};
</script>
